import { Injectable } from '@angular/core';
import {Observable, BehaviorSubject} from "rxjs";

export interface IBreadcrumb {
  label: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {

    private prefixedBreadcrumbs: IBreadcrumb[] = [{
      url: '/online-fair',
      label: $localize`Online fair`
    }];
    // private breadcrumbs:IBreadcrumb[];

    private breadcrumbsSource$: BehaviorSubject<IBreadcrumb[]>;

    constructor() {
        this.breadcrumbsSource$ = new BehaviorSubject<IBreadcrumb[]>(null);

    }

    // Store the breadcrumbs of the current route
    public store(breadcrumbs: IBreadcrumb[]): void {
        const allBreadcrumbs = this.prefixedBreadcrumbs.concat(breadcrumbs);
        // this.breadcrumbs = allBreadcrumbs;
        this.breadcrumbsSource$.next(allBreadcrumbs);
    }

    // public appendBreadCrumbs(breadcrumbs:IBreadcrumb[]): void {
    //   this.breadcrumbs = this.breadcrumbs.concat(breadcrumbs);
    //   this.breadcrumbsSource$.next(this.breadcrumbs);
    // }

    // Return the breadcrumbs as observable
    public get breadcrumbs$(): Observable<IBreadcrumb[]> {
        return this.breadcrumbsSource$.asObservable();
    }

}
